@if (isUserAuthenticated) {
  <ul
    class="nav-list list-unstyled user-details-wrap p-0 m-0">
    <li class="list-inline-item align-bottom">
      <!-- user's details -->
      <main-header-user-details [user]="usersData">
      </main-header-user-details>
      <!-- /user's details -->
    </li>
  </ul>
} @else {
  <user-login-button></user-login-button>
}
<!-- user-login-button -->
<!-- /user-login-button -->